/** Pending-file queue helpers used by create/edit submit before the save API. */

/** True when at least one selected file will upload before the save API. */
export function hasPendingUploadFiles(
  pendingFiles: Record<string, File | null | undefined>,
): boolean {
  return Object.values(pendingFiles).some(Boolean);
}

/** Upload every pending file in parallel; returns key → stored URL. */
export async function uploadPendingFiles(
  pendingFiles: Record<string, File | null | undefined>,
  upload: (file: File) => Promise<string>,
): Promise<Record<string, string>> {
  const queued = Object.entries(pendingFiles).filter((entry): entry is [string, File] =>
    Boolean(entry[1]),
  );
  const uploaded = await Promise.all(
    queued.map(([key, file]) => upload(file).then((url) => [key, url] as const)),
  );
  return Object.fromEntries(uploaded);
}
